import * as Component from 'components';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { accountStore } from 'store/accountStore';
import * as ContentComponent from '../components';
import './LibraryEdit.css';

const LibraryEdit: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const contentType = searchParams.get('content_type');
  const videoComponents = [
    {
      key: 'detail',
      title: 'Detail',
      component: <ContentComponent.DetailComponent />,
    },
    {
      key: 'transcode',
      title: 'Transcode (deprecated)',
      component: <ContentComponent.TranscodeComponent />,
    },
    {
      key: 'contract',
      title: 'Contract',
      component: <ContentComponent.ContractComponent />,
    },
    {
      key: 'revenue-share',
      title: 'Revenue Share',
      component: (
        <ContentComponent.RevenueComponent
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      ),
    },
    {
      key: 'service',
      title: 'Service',
      component: <ContentComponent.ServiceComponent />,
    },
    {
      key: 'clip',
      title: 'Clip & Trailer',
      component: <ContentComponent.ClipTrailerComponent />,
    },
    {
      key: 'video-assets',
      title: 'Video Profiles',
      component: <ContentComponent.VideoAssetsComponent />,
    },
  ];

  const userPlatform = accountStore.getAccount()!.platform;
  const keyList =
    userPlatform.id === 2
      ? ['detail', 'poster', 'subtitle', 'dubbing', 'transcode']
      : [
          'detail',
          'poster',
          'subtitle',
          'dubbing',
          'transcode',
          'contract',
          'revenue-share',
          'service',
          'video-assets',
        ];

  if (contentType === 'movie') {
    keyList.push('clip');
  }

  const filteredComponents = videoComponents.filter(component => keyList.includes(component.key));
  return (
    <div>
      <Component.BasePageComponent>
        <h1>{contentType || 'video'}</h1>
        <Component.TapComponent
          components={filteredComponents}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </Component.BasePageComponent>
    </div>
  );
};

export default LibraryEdit;
